'use strict';

var waterfall = require('async/waterfall');

var CID = require('cids');

var log = require('debug')('ipfs:mfs:utils:load-node');

var loadNode = function loadNode(ipfs, object, callback) {
  var multihash = object && (object.multihash || object.hash);

  if (!multihash) {
    log("No multihash passed so cannot load DAGNode");
    return callback();
  }

  var cid = new CID(multihash);
  log("Loading DAGNode for child ".concat(cid.toBaseEncodedString()));
  waterfall([function (cb) {
    return ipfs.dag.get(cid, cb);
  }, function (result, cb) {
    return cb(null, result.value);
  }], callback);
};

module.exports = loadNode;